import React from "react";
import ContextualListGroup from '../../Component/Ui Component/ContextualListGroup';
import FlushListGroup from '../../Component/Ui Component/FlushListGroup';
import { Link } from "react-router-dom";


function ListGroup (){
    return(
        <div className="container">
            <div className="col-12">
                <div className="card p-4 bd-content">
                    <h1>List group</h1>
                    <p>List groups are a flexible and powerful component for displaying a series of content. Modify and extend them to support just about any content within.</p>
                    <div className="alert alert-danger" role="alert">
                            <strong>List group</strong> for more bootstrao components <Link to="https://v5.getbootstrap.com/docs/5.0/components/list-group/" target="_blank" rel="noopener noreferrer">Bootstrap List group documentation <i className="fa fa-external-link"></i></Link>
                    </div>
                    <FlushListGroup />
                    <ContextualListGroup />
                </div>
            </div>
        </div>
    )
  }

export default ListGroup;